import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Row,
  Col,
  Button,
} from "react-bootstrap";
// import { useLogout } from "../../utilities";
import adminMenuItems from "../../constants/adminMenuItems";
import { useState } from "react";
import { ModalMessage } from "../../components";

export default function AdminHome() {
  // displays the admin menu with links to subpages

    // const logout = useLogout();
const [showLogoutMsg, setShowLogoutMsg] = useState(false);

  return (
    <Container  className="mt-5">
      <Row className="mt-5 justify-content-md-center" style={{textAlign: "center"}}>
      <h1>Admin Menu</h1>
      <Col
        md={6}
        className="p-4 mt-3 d-grid gap-2"
        style={{ borderRadius: "20px", display: "flex", flexDirection: "column", alignItems: "center"}}
      >
        {adminMenuItems.map((menuItem, idx) => (
        <LinkContainer to={menuItem.path} key={idx}>
            <Button variant={idx%2===0 ? "secondary" : "dark"}>{menuItem.label}</Button>
          </LinkContainer>
        ))}
            
        <Button onClick={() => setShowLogoutMsg(true)} variant="outline-dark">Logout</Button>
      </Col>
    </Row>
          {/* logout alert message */}
          {showLogoutMsg && 
      <ModalMessage
          message="Are you sure you want to logout? Any open chats you may have will be closed."
          // setErrorMsg={setShowLogoutMsg}
          showLogoutButton={true}
          setShowLogoutMsg={setShowLogoutMsg}
        /> }
    </Container>
  );
}
